import React from 'react'
import PropTypes from 'prop-types'
import styles from '../index.module.css'

/**
 * Component that displays a preview of the previous page the user was on
 * and allows them to select it for prefilling the form
 */
const PreviousPagePreview = ({ pageUrl, pageTitle, onSelect }) => {
  if (!pageUrl) return null
  
  const handleClick = () => {
    onSelect(pageUrl)
  }
  
  return (
    <div className={styles.prevPagePreview} onClick={handleClick}>
      <div className={styles.prevPageTitle}>
        {pageTitle || 'Recently Visited Item'}
      </div>
      <div className={styles.prevPageUrl}>{pageUrl}</div>
    </div>
  )
}

PreviousPagePreview.propTypes = {
  pageUrl: PropTypes.string,
  pageTitle: PropTypes.string,
  onSelect: PropTypes.func.isRequired
}

export default PreviousPagePreview